import VerificationFreshness from './VerificationFreshness';

export {
  DEFAULT_STALE_DAYS,
  daysSinceVerified,
  isVerificationStale,
  isVerifiedThroughLapsed
} from './VerificationFreshness';
export default VerificationFreshness;
